import axios from 'axios';

// Use the same origin as the current page to avoid cross-site cookie issues
const API_BASE_URL = typeof window !== 'undefined'
    ? `${window.location.origin}/api`
    : (process.env.REACT_APP_API_URL || 'http://localhost:8000/api');

const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true, // Enable session cookies
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

// Token management
let authToken = localStorage.getItem('auth_token');

export const setAuthToken = (token) => {
    authToken = token;
    localStorage.setItem('auth_token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const removeAuthToken = () => {
    authToken = null;
    localStorage.removeItem('auth_token');
    delete api.defaults.headers.common['Authorization'];
};

export const getAuthToken = () => {
    return authToken;
};

// Set token if exists on init
if (authToken) {
    api.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
}

// Response interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle 401 Unauthorized - token expired or invalid session
        if (error.response?.status === 401) {
            removeAuthToken();
            // Auto redirect to login
            const currentPath = window.location.pathname;
            // Don't redirect if already on login or public pages
            if (currentPath.startsWith('/admin')) {
                window.location.href = '/login';
            }
        }

        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);

export default api;
